import { VerifyEmailAddressErrors } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const verifyEmail = async (email: string): Promise<VerifyEmailAddressErrors[] | undefined> => {
  try {
    const response = await applicationFormService.verifyEmail(email);
    return response?.data?.verifyEmail?.verifyEmailErrors;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        const forbiddenErrMsg = createForbiddenErrorMessage(err);
        error.forbiddenError = forbiddenErrMsg;
        break;
      case 401:
        const unauthErrMsg = createUnauthorizedErrorMessage(err);
        error.unauthorizedError = unauthErrMsg;
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default verifyEmail;
